<template>
  <div id="networking">
    <div class="container">
      <div class="header-block">
        <InfoBlock :title="$getModuleTitle(currentEvent.modules, 'networking')" :desc="$t('networking.description')" :button="null" :url="null" />
      </div>

      <Nodata :title="$getModuleTitle(currentEvent.modules, 'networking')" :description="saloonId == null && searchTerm == null && searchTerm != '' ? $t('contentNotFound') : $t('contentFilterNotFound')" anim="holacon-networking-lottie" :loading="$store.state.eventLoading == 'rooms'" v-if="currentRooms.length == 0" :button="$t('refresh')" @btnClick="$store.dispatch('getRooms', { id: currentEvent.id, searchTerm: null, route: false })" />

      <div class="networking-rooms">
        <NetworkingBlock :data="currentRooms" />
      </div>

      <!-- <infinite-loading @infinite="getData">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading> -->
    </div>
  </div>
</template>

<script>
import moment from "moment";
import NetworkingBlock from "../../modules/NetworkingBlock";
import InfoBlock from "../../modules/InfoBlock";
import InfiniteLoading from "vue-infinite-loading";

export default {
  name: "Networking",
  components: { NetworkingBlock, InfoBlock, InfiniteLoading },
  data() {
    return {
      saloonId: null,
      searchTerm: null,
      moment,
      searchTerm: null,
      timeout: null,
      sortKey: +new Date(),
    };
  },

  methods: {
    searchFilter() {
      if (this.searchTerm != null && this.timeout == null) {
        this.timeout = setTimeout(() => {
          this.$store.dispatch("getRooms", { searchTerm: this.searchTerm, id: this.currentEvent.id, route: false });
          this.timeout = null;
        }, 1000);
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch("getRooms", { id: this.currentEvent.id, route: false });
    });

    this.$socket.emit("subscribe", {
      channel: "networking-" + this.currentEvent.id,
      token: ""
    });

    this.$socket.emit("subscribe", {
      channel: "networking-area-" + this.currentEvent.id,
      token: ""
    });

    this.$socket.off("networking-area-" + this.currentEvent.id + "-itemChanged");
    this.$socket.on("networking-area-" + this.currentEvent.id + "-itemChanged", data => {
      var data2 = data.data;
      var users = [];
      var id = data2.item.Id;
      if (data2 != null && data2.item != null && data2.item.Users != null) {
        data2.item.Users.map(i => {
          users.push({
            firstName: i.FirstName,
            lastName: i.LastName,
            image: i.Image,
            id: i.Id
          });
        });

        var index = this.currentRooms.findIndex(k => k.id == id);
        if (index != -1) {
          this.currentRooms[index].users = users;
        }
      }
    });

    this.$socket.off("networking-" + this.currentEvent.id + "-networkingAreaUpdated");
    this.$socket.on("networking-" + this.currentEvent.id + "-networkingAreaUpdated", data => {
      var data2 = data.data.Item;
      var roomData = {
        title: data2.Title,
        peopleCount: data2.PeopleCount,
        backgroundBanner: data2.BackgroundBanner,
        cover: data2.Cover,
        orderNO: data2.OrderNO,
        watcherCount: data2.WatcherCount
      };

      var index = this.currentRooms.findIndex(k => k.id == data2.Id);
      if (index != -1) {
        var roomData2 = {
          ...this.currentRooms[index],
          ...roomData
        };
        this.$store.commit("updateRoom", {
          data: roomData2,
          index
        });
        if (this.currentRoom != null) {
          this.$store.commit("setCurrentRoom", roomData2);
        }
      } else {
        this.$store.commit("setAddRoom", {
          id: data2.Id,
          managers: data2.Managers,
          users: data2.Users,
          title: data2.Title,
          peopleCount: data2.PeopleCount,
          backgroundBanner: data2.BackgroundBanner,
          cover: data2.Cover,
          orderNO: data2.OrderNO,
          watcherCount: data2.WatcherCount,
          sfuUrl: data2.SfuUrl,
          createDate: data2.CreateDate,
          updateDate: data2.UpdateDate,
          recordStatus: data2.RecordStatus,
          isActive: data2.ISActive
        });
      }
    });

    this.$socket.off("networking-" + this.currentEvent.id + "-networkingAreaSortingChanged");
    this.$socket.on("networking-" + this.currentEvent.id + "-networkingAreaSortingChanged", data => {
      var networkingRooms = data.data.Items;
      for(var i = 0; i < networkingRooms.length; i++)
      {
        var element = networkingRooms[i];
        var index = this.currentRooms.findIndex(k => k.id == element.Id);
        if(index != -1)
        {
          this.currentRooms[index].orderNO = element.OrderNO;
        }
      }
       this.$store.commit("setRooms", this.currentRooms);
    });

    this.$socket.on("networking-" + this.currentEvent.id + "-networkingAreaRemoved", data => {
      this.$store.commit("removeNetworking", data.data.Id);
      console.warn("data:",data.data.Id, 'router', this.$route.params.network_id);
    });
  },
  beforeDestroy() {
    this.$socket.emit("unsubscribe", "networking-" + this.currentEvent.id);
    this.$socket.emit("unsubscribe", "networking-area-" + this.currentEvent.id);
  },

  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentRooms() {
      return this.$store.getters.getRooms;
    },
    currentRoom() {
      return this.$store.getters.getCurrentRoom;
    }
  }
};
</script>

<style lang="less">
#networking {
  background-color: #F1F3F6;

  min-height: calc(~"100vh");
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 20px;

  .container {
    display: block;
    max-width: 1120px;
    width: inherit;
    margin: 0 auto;
    margin-bottom: 40px;

    .networking-rooms {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 16px;
      margin: 0px;
    }
  }
}

@media (max-width: 768px) {
  #networking {
    padding: 0px;
    padding-bottom: 60px;

    .container {
      padding: 0px 12px;
      .networking-rooms {
        grid-template-columns: 1fr !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/Networking.vue